import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import { http } from './http';

var AssetService = /*#__PURE__*/function () {
  function AssetService() {
    _classCallCheck(this, AssetService);
  }

  _createClass(AssetService, [{
    key: "getPlansForAsset",
    value: function () {
      var _getPlansForAsset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return http.post('asset-access/plans', payload);

              case 2:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getPlansForAsset(_x) {
        return _getPlansForAsset.apply(this, arguments);
      }

      return getPlansForAsset;
    }()
  }, {
    key: "getServicePlansForAsset",
    value: function () {
      var _getServicePlansForAsset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(serviceId, payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return http.post("asset-access/plans/".concat(serviceId), payload);

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", result.data);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getServicePlansForAsset(_x2, _x3) {
        return _getServicePlansForAsset.apply(this, arguments);
      }

      return getServicePlansForAsset;
    }()
  }, {
    key: "setPlansForAsset",
    value: function () {
      var _setPlansForAsset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(payload) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return http.post('asset-access/setPlans', payload);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function setPlansForAsset(_x4) {
        return _setPlansForAsset.apply(this, arguments);
      }

      return setPlansForAsset;
    }()
  }]);

  return AssetService;
}();

var assetService = new AssetService();
export default assetService;